var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "stocktransfer"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.viewSTNmodal = false
      }
    },
    model: {
      value: (_vm.viewSTNmodal),
      callback: function($$v) {
        _vm.viewSTNmodal = $$v
      },
      expression: "viewSTNmodal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSTNModel),
      expression: "showSTNModel"
    }],
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('div', {
    staticClass: "modal-headerfrm",
    staticStyle: {
      "margin": "-21px !important"
    }
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.stockTransferDetails')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeviewSTNmodal
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body",
    staticStyle: {
      "padding": "0.25rem !important"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.stnID')) + ":  " + _vm._s(_vm.stnidDetails))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.status')) + ": " + _vm._s(_vm.Details.status))])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')) + ": ")]), _vm._v(" " + _vm._s(_vm.sourceWarehouseDetails.warehousename))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sourceWarehouseDetails.warehouseaddress) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.state')) + ":  " + _vm._s(_vm.sourceWarehouseDetails.warehousestate) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.sourceWarehouseDetails.warehousecity) + " - " + _vm._s(_vm.sourceWarehouseDetails.warehousepincode) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactPerson')) + ":  " + _vm._s(_vm.sourceWarehouseDetails.contactpersonname) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactNo')) + ":  " + _vm._s(_vm.sourceWarehouseDetails.contactno) + " ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')) + ":")]), _vm._v("  " + _vm._s(_vm.destinationWarehouseDetails.warehousename))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.destinationWarehouseDetails.warehouseaddress) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.state')) + ":  " + _vm._s(_vm.destinationWarehouseDetails.warehousestate) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.destinationWarehouseDetails.warehousecity) + " - " + _vm._s(_vm.destinationWarehouseDetails.warehousepincode) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactPerson')) + ":  " + _vm._s(_vm.destinationWarehouseDetails.contactpersonname) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.contactNo')) + ":  " + _vm._s(_vm.destinationWarehouseDetails.contactno) + " ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.totalSku')) + ": " + _vm._s(_vm.Details.nooflines) + " ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.totalSku')) + ": " + _vm._s(_vm.Details.totalqty)), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')) + ": " + _vm._s(_vm.Details.transportername)), _c('br')])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.createdBy')) + ": " + _vm._s(_vm.Details.createdby)), _c('br')])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.createdDate')) + " : " + _vm._s(_vm._f("moment")(_vm.Details.createddate))), _c('br')])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "60%"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')) + ": " + _vm._s(_vm._f("moment")(_vm.Details.requireddate))), _c('br')])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', [_c('table', {
    staticClass: "table-bordered table",
    staticStyle: {
      "position": "relative",
      "overflow": "auto",
      "font-size": "12px",
      "margin-left": "16px"
    }
  }, [_c('thead', {
    staticClass: "table table-bordered mytable12"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "display": "table-cell",
      "text-align": "left",
      "height": "40px",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineNo')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productUom')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productMrp')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requestedQty')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.allocatedQty')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.unallocatedQty')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "110px",
      "text-align": "center",
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineStatus')))])])]), _vm._v(" "), _vm._l((_vm.STNDetails), function(data, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.uom))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.requestedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.allocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.unallocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.linestatus))])])])
  }), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('div', {
    staticClass: "downarr"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.totalValue')))])]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.twoDecimal(_vm.STNsubtotal)))])])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('stockTransfer.acknowledgementMsg')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.date')))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.yourName')))]), _c('br'), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.yourDesignation')))])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting d-sm-down-none",
    on: {
      "click": _vm.addNewSTN
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchsourceFC),
      expression: "searchsourceFC"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('not_in:Choose'),
      expression: "'not_in:Choose'"
    }],
    staticClass: "form-control",
    on: {
      "click": _vm.warehouseSelected,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchsourceFC = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderFC')))]), _vm._v(" "), _vm._l((_vm.listSourceFCData), function(source_obj) {
    return _c('option', {
      domProps: {
        "value": source_obj.warehouseid
      }
    }, [_vm._v(_vm._s(source_obj.warehousename))])
  })], 2)])], 1), _vm._v(" "), (_vm.showSelectWarehouse) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchdestinationFC),
      expression: "searchdestinationFC"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('not_in:Choose'),
      expression: "'not_in:Choose'"
    }],
    staticClass: "form-control",
    on: {
      "click": function($event) {},
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchdestinationFC = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderFC')))]), _vm._v(" "), _vm._l((_vm.listDestinationFCData), function(destination_obj) {
    return _c('option', {
      domProps: {
        "value": destination_obj.warehouseid
      }
    }, [_vm._v(_vm._s(destination_obj.warehousename))])
  })], 2)])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.stnID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('stockTransfer.stnPlaceholderId')
    },
    model: {
      value: (_vm.searchSTNID),
      callback: function($$v) {
        _vm.searchSTNID = $$v
      },
      expression: "searchSTNID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchtransporter),
      expression: "searchtransporter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('not_in:Choose'),
      expression: "'not_in:Choose'"
    }],
    staticClass: "form-control",
    on: {
      "click": _vm.getTransportList,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchtransporter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderTransporter')))]), _vm._v(" "), _vm._l((_vm.listTransportData), function(transporter_obj) {
    return _c('option', {
      domProps: {
        "value": transporter_obj.transportname
      }
    }, [_vm._v(_vm._s(transporter_obj.transportname))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.status')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('not_in:Choose'),
      expression: "'not_in:Choose'"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderSTN')))]), _vm._v(" "), _vm._l((_vm.liststatusData), function(status_obj) {
    return _c('option', {
      domProps: {
        "value": status_obj.status
      }
    }, [_vm._v(_vm._s(status_obj.status))])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.creationDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "editable": false,
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.searchcreationdate),
      callback: function($$v) {
        _vm.searchcreationdate = $$v
      },
      expression: "searchcreationdate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getSTNData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFormData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('stockTransfer.stnList')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.stnID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.status')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.clientName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.totalQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.noOfLine')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.createdDate')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.createdBy')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.action')))])])]), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.noRecordFoundMsg')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listSTNData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left ",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.stnid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.sourcewarehousename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.destinationwarehousename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.nooflines))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.transportername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.requireddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', [(data.status == 'confirmed' || data.status == 'rackout') ? _c('i', {
      staticClass: "fa fa-lock text-successlock fa-lg mt-2 ml-3"
    }) : _vm._e(), _vm._v(" "), (data.status == 'created') ? _c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getSTNRowData(data.stnid, data.clientid)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          _vm.getSTNRowDetails(data.stnid, data.clientid)
        }
      }
    })])])
  })], 2)])]), _c('br'), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.checkStockmodel = false
      }
    },
    model: {
      value: (_vm.checkStockmodel),
      callback: function($$v) {
        _vm.checkStockmodel = $$v
      },
      expression: "checkStockmodel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.viewSTN')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hidecheckStockmodel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.stnID')) + ":")]), _vm._v(_vm._s(_vm.stnidDetails))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.status')) + ":")]), _vm._v(_vm._s(_vm.Details.status))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')) + ":")]), _vm._v(_vm._s(_vm.Details.sourcewarehouse))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')) + ":")]), _vm._v(_vm._s(_vm.Details.destinationname))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.totalQty')) + ":")]), _vm._v(_vm._s(_vm.Details.totalqty))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')) + ":")]), _vm._v(_vm._s(_vm.Details.transportername))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.createdBy')) + ":")]), _vm._v(_vm._s(_vm.Details.createdby))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')) + ":")]), _vm._v(_vm._s(_vm._f("moment")(_vm.Details.requireddate)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('stockTransfer.createdDate')) + ":")]), _vm._v(_vm._s(_vm._f("moment")(_vm.Details.createddate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineNo')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.ProductDesc')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productUom')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productMrp')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requestedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.allocatedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.unallocatedQty')))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.lineStatus')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.STNDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.productdescription))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.uom))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.requestedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.allocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.unallocatedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.linestatus))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  })])])]), _vm._v(" "), (_vm.pageCount > 0) ? _c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "total-rows": _vm.pageCount * _vm.pageLimit,
      "per-page": _vm.pageLimit,
      "aria-controls": "my-table",
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "input": function($event) {
        _vm.getPaginationData(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.addSTNmodal = false
      }
    },
    model: {
      value: (_vm.addSTNmodal),
      callback: function($$v) {
        _vm.addSTNmodal = $$v
      },
      expression: "addSTNmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.STNaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.addStn')))]) : _vm._e(), _vm._v(" "), (_vm.STNaction == 'edit') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.editStn')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAddSTNModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFC')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceFC),
      expression: "sourceFC"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('sourceFC')
    },
    attrs: {
      "name": "sourceFC"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceFC = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChangeClientWarehouse],
      "click": _vm.getTransportList
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderFC')))]), _vm._v(" "), _vm._l((_vm.listSourceFCData), function(source_obj) {
    return _c('option', {
      domProps: {
        "value": source_obj.warehouseid
      }
    }, [_vm._v(_vm._s(source_obj.warehousename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('sourceFC')),
      expression: "errors.has('sourceFC')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.sourceFCError')))])], 1), _vm._v(" "), (_vm.showSelectWarehouse) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFC')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.destinationFC),
      expression: "destinationFC"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('destinationFC')
    },
    attrs: {
      "name": "destinationFC"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.destinationFC = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderFC')))]), _vm._v(" "), _vm._l((_vm.listDestinationFCData), function(destination_obj) {
    return _c('option', {
      domProps: {
        "value": destination_obj.warehouseid
      }
    }, [_vm._v(_vm._s(destination_obj.warehousename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationFC')),
      expression: "errors.has('destinationFC')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.destinationFCError')))])], 1) : _vm._e()])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.transporter')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transporter),
      expression: "transporter"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('transporter')
    },
    attrs: {
      "name": "transporter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.transporter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.selectPlaceholderTransporter')))]), _vm._v(" "), _vm._l((_vm.listTransportData), function(transporter_obj) {
    return _c('option', [_vm._v(_vm._s(transporter_obj.transportname))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('transporter')),
      expression: "errors.has('transporter')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.transporterError')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 purchsOrd"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('stockTransfer.requiredDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('v-date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'error': _vm.errors.has('requireddate')
    },
    attrs: {
      "mode": "single",
      "name": "requireddate",
      "input-props": {
        class: "select",
        readonly: true
      }
    },
    model: {
      value: (_vm.requireddate),
      callback: function($$v) {
        _vm.requireddate = $$v
      },
      expression: "requireddate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('requireddate')),
      expression: "errors.has('requireddate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.requireddateError')))])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: " table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "data-v-732d89fa1": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.line')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-v-732d89fa2": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productName')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-v-732d89fa3": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.productID')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-v-732d89fa4": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('product.productDescription')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-v-732d89fa6": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.uom')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-v-732d89fa7": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.mrp')))]), _vm._v(" "), _c('th', {
    attrs: {
      "data-v-732d89fa5": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.qty')))]), _vm._v(" "), (_vm.STNaction == 'edit') ? _c('th', {
    attrs: {
      "data-v-732d89fa9": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.action')))]) : _vm._e(), _vm._v(" "), (_vm.STNaction == 'add') ? _c('th', {
    attrs: {
      "data-v-732d89fa9": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('common.table.action')))]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.itemsWithSubTotal), function(invoice_item, index) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.productname),
        expression: "invoice_item.item.productname"
      }],
      staticClass: "form-control",
      class: {
        disabled: _vm.isDisabled
      },
      attrs: {
        "list": "newssources-list",
        "disabled": _vm.isDisabled,
        "name": "source-selection",
        "id": "source-selection",
        "placeholder": _vm.$t('stockTransfer.productPlaceHolder'),
        "ind": index,
        "autocomplete": "off"
      },
      domProps: {
        "value": (invoice_item.item.productname)
      },
      on: {
        "change": _vm.sourceChanged,
        "keyup": _vm.getProducts,
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.productname = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.productid),
        expression: "invoice_item.item.productid"
      }],
      staticClass: "form-control",
      class: {
        disabled: _vm.isDisabled
      },
      attrs: {
        "type": "text",
        "disabled": _vm.isDisabled,
        "placeholder": _vm.$t('stockTransfer.productIdPlaceHolder'),
        "readonly": ""
      },
      domProps: {
        "value": (invoice_item.item.productid)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.productid = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.productdescription),
        expression: "invoice_item.item.productdescription"
      }],
      staticClass: "form-control",
      class: {
        disabled: _vm.isDisabled
      },
      attrs: {
        "type": "text",
        "disabled": _vm.isDisabled,
        "placeholder": _vm.$t('stockTransfer.productDescPlaceHolder'),
        "readonly": ""
      },
      domProps: {
        "value": (invoice_item.item.productdescription)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.productdescription = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.primaryuom),
        expression: "invoice_item.item.primaryuom"
      }],
      staticClass: "form-control",
      class: {
        disabled: _vm.isDisabled
      },
      attrs: {
        "type": "text",
        "disabled": _vm.isDisabled,
        "placeholder": _vm.$t('stockTransfer.uomPlaceHolder')
      },
      domProps: {
        "value": (invoice_item.item.primaryuom)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.primaryuom = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (invoice_item.item.mrp),
        expression: "invoice_item.item.mrp"
      }],
      staticClass: "form-control",
      class: {
        disabled: _vm.isDisabled
      },
      attrs: {
        "name": "mrp",
        "id": index,
        "disabled": _vm.isDisabled
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          invoice_item.item.mrp = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('stockTransfer.mrp')))]), _vm._v(" "), _vm._l((_vm.listMRPData[invoice_item.item.productid]), function(mrp_obj) {
      return (_vm.STNaction == 'edit' && invoice_item.item.itemid > 0) ? _c('option', {
        domProps: {
          "value": mrp_obj.mrp
        }
      }, [_vm._v("Rs." + _vm._s(mrp_obj.mrp) + " (" + _vm._s(mrp_obj.totalstock) + ")")]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (invoice_item.item.quantity),
        expression: "invoice_item.item.quantity",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control",
      class: (_vm.qtyshowerror == true && invoice_item.item.productid != '' && invoice_item.item.quantity == '') ? 'input-invalid' : '',
      attrs: {
        "type": "text",
        "name": "quantity",
        "disabled": _vm.isDisabled,
        "placeholder": _vm.$t('stockTransfer.qtyPlaceHolder')
      },
      domProps: {
        "value": (invoice_item.item.quantity)
      },
      on: {
        "change": function($event) {
          _vm.CheckQuantity(index)
        },
        "input": [function($event) {
          if ($event.target.composing) { return; }
          invoice_item.item.quantity = _vm._n($event.target.value)
        }, function($event) {
          _vm.checkqty(invoice_item.item.quantity)
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), (_vm.STNaction == 'edit' && invoice_item.item.itemid > 0) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          _vm.removeRow(index)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.STNaction == 'add' || !(invoice_item.item.itemid > 0)) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          _vm.clearRow(index)
        }
      }
    })]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.addItem')))]), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": "newssources-list"
    }
  }, _vm._l((_vm.products), function(source) {
    return _c('option', {
      attrs: {
        "label": source.productname
      },
      domProps: {
        "value": source.productname
      }
    })
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "STNfooter form-actions",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.STNaction == 'add') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "stnstnaction",
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.saveSTN(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.saveBtn')))]) : _vm._e(), _vm._v(" "), (_vm.STNaction == 'edit') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "stnstnaction",
      "type": "submit",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.updateSTN(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.updateBtn')))]) : _vm._e(), _vm._v(" "), (_vm.STNaction == 'add') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "id": "stnstnaction",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.saveSTN(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.btnSaveCnfrm')))]) : _vm._e(), _vm._v(" "), (_vm.STNaction == 'edit') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "17%"
    },
    attrs: {
      "id": "stnstnaction",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.updateSTN(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('stockTransfer.btnUpdateCnfrm')))]) : _vm._e()])])], 1)])])], 1)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a1b1718", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a1b1718","hasScoped":true}!./src/views/components/stocktransfer/stocktransfer.component.html
// module id = 850
// module chunks = 0